import { render, staticRenderFns } from "./ActionCheckPotentialContractDuplicates.vue?vue&type=template&id=25d6bc5b&scoped=true&"
import script from "./ActionCheckPotentialContractDuplicates.vue?vue&type=script&lang=js&"
export * from "./ActionCheckPotentialContractDuplicates.vue?vue&type=script&lang=js&"
import style0 from "./ActionCheckPotentialContractDuplicates.vue?vue&type=style&index=0&id=25d6bc5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d6bc5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCol,VIcon,VOverlay,VProgressCircular,VRow,VTab,VTabs})
